import Balloon from '@/objects/balloon';
import GameOverPopup from '@/objects/gameOverPopup';
import BaseCharacter from '@/objects/baseCharacter';
import PausePopup from '@/objects/pausePopup';
import HelpPopup from '../objects/helpPopup';

export default class Game extends Phaser.Scene {
  /**
   *  A sample Game scene, displaying the Phaser logo.
   *
   *  @extends Phaser.Scene
   */
  constructor() {
    super({ key: 'Game' });
  }

  /**
   *  Called when a scene is initialized. Method responsible for setting up
   *  the game objects of the scene.
   *
   *  @protected
   *  @param {object} data Initialization parameters.
   */

  init(data) {
    this.firstRun = data.firstRun !== false;
    this.lastBG = data.lastBG;
  }

  create(/* data */) {

    let prevMute = localStorage.getItem('mute');
    this.mute = prevMute !== undefined ? prevMute === 'true' : false;
    this.toggleMute(this.mute);
    this.backgroundGroup = this.add.group();
    this.staticChars = this.add.group();
    this.characterGroup = this.add.group();
    this.balloonGroup = this.add.group();
    this.textGroup = this.add.group();
    this.popupGroup = this.add.group();
    this.gameConfig = this.cache.json.get('data').gameConfig;
    this.endConfig = this.cache.json.get('data').endConfig;
    this.helpConfig = this.cache.json.get('data').helpConfig;
    this.balloonData = this.gameConfig.balloons.physics;
    this.gravity = this.balloonData.gravity;
    this.currentGravity = this.gravity;
    this.gamePlaying = false;

    this.level = 1;

    this.transitionCount = this.gameConfig.levelCount[this.level];
    console.log("transition count", this.transitionCount);
    this.backgrounds = this.lastBG !== undefined ? this.lastBG : Phaser.Math.Between(
      0,
      this.gameConfig.backgrounds.length - 1
    );
    this.balloonColourCount = this.gameConfig.balloons.colours.length;
    this.balloonIndex = 0; // Phaser.Math.Between(0, this.balloonColourCount - 1);
    this.collisionPlayed = false;
    this.characters = [];
    this.events = [];
    this.pausedTweens = [];
    this.setupCharacters(this.gameConfig);
    for (var i = 0; i < 2; i++) {
      this.staticChars.create(0, 0, 'blank');
    }
    this.changeBackground();
    this.transitionDirection = this.gameConfig.backgrounds[this.prevBackgrounds].transitionDirection;
    console.log(this.backgrounds, this.transitionDirection);
    //  TODO: Replace this content with really cool game code here :)
    this.count = 0;
    this.totalCount = 0;
    this.balloons = [];

    const screenX = this.cameras.main.width;
    // const screenY = this.cameras.main.height;
    this.paused = false;
    this.initBalloons(screenX);

    let scoreX = 20;
    let scoreY = 10;

    let scoreBG = this.add.image(scoreX, scoreY, 'score_box');
    scoreBG.setOrigin(0, 0);
    scoreBG.setDepth(10);
    // this.counter = this.add.bitmapText(
    //   scoreBG.x + scoreBG.displayWidth / 2,
    //   scoreY + scoreBG.y + scoreBG.displayHeight / 2,
    //   this.gameConfig.font,
    //   0
    // );

    this.counter = this.add.text(scoreBG.x + scoreBG.displayWidth / 2, scoreY + scoreBG.y + scoreBG.displayHeight / 2, 0, {fontFamily: '"Hello Headline'});


    this.counter.setOrigin(0.5, 0.75);
    this.counter.setFontSize(88);
    // this.counter.setCenterAlign();
    this.counter.setDepth(scoreBG.depth + 1);
    this.textGroup.add(scoreBG);
    this.textGroup.add(this.counter);

    this.canPlaySFX = true;

    this.helpPopup = new HelpPopup(this, this.popupGroup, this.helpConfig);
    this.pausePopup = new PausePopup(this, this.popupGroup);
    this.pausePopup.emitter.on('gameResumed', this.handleResumed, this);
    this.helpPopup.emitter.on('gameResumed', this.handleResumed, this);
    this.pausePopup.emitter.on('helpRequested', this.showHelp, this);
    this.pauseBtn = this.add.image(screenX - 10, 10, 'pauseBtn');
    this.pauseBtn.setOrigin(1, 0);
    this.pauseBtn
      .setInteractive({ useHandCursor: true })
      .on('pointerdown', () => {
        if (this.paused === false) {
          if (this.pausePopup.active == false) {
            this.pausePopup.show(this);
          } this.handlePaused();
        }
      });

    this.pauseBtn.setDepth(10);

    this.input.on('pointerup', () => this.inputDown = false, this);

    this.idleIdx = 0;
    this.idleSFX = this.cache.json.get('data').idleSFX;
    this.idleSFX.sort(() => Math.random() - 0.5);

    this.bgMusic = this.sound.add('bgmusic', {
      loop: true,
      volume: 0.75
    });
    this.bgMusic.play();
    if (this.firstRun === true) {
      this.showHelp(false);
    }
    else {
      this.gamePlaying = true;
    }
  }

  initBalloons(screenX) {
    if (this.gameConfig.balloons.startAmount !== undefined && this.gameConfig.balloons.startAmount > 1) {
      for (let i = 0; i < this.gameConfig.balloons.startAmount; i++) {
        let x = Phaser.Math.Between(150, this.cameras.main.width - 150);
        let y = Phaser.Math.Between(150, 400);
        this.createBalloon(x, y, true);
      }
    }
    else {
      this.createBalloon(screenX / 2, 150, true);
    }
    this.popConfig = this.gameConfig.balloons.popConfig;
    var popFrames = [];
    for (let j = 0; j < this.popConfig.frames.length; j++) {
      popFrames.push({ key: this.popConfig.frames[j] });
    }
    // console.log(popFrames);
    let genFrames = this.anims.generateFrameNames('sprites', { prefix: 'pop', start: 1, end: 4, suffix: '.png' });
    let anim = {
      key: this.popConfig.name,
      frames: genFrames,
      frameRate: this.popConfig.frameRate
    };
    this.anims.create(anim);

    this.input.on('pointerdown', function (pointer) {
      if (this.inputDown !== true && this.gamePlaying) {

        if (this.paused === false) {
          for (let i = 0; i < this.balloons.length; i++) {
            this.balloons[i].checkTap(pointer);

          }
        }
        this.inputDown = true;
      }
    }, this);
  }

  toggleMute(toggleOn) {
    this.mute = toggleOn;
    localStorage.setItem('mute', this.mute);
    this.sound.setMute(this.mute);
  }

  handlePaused() {
    this.paused = true;
    //console.log('PAUSED');
    if (this.endEvent !== undefined) {
      this.endEvent.paused = true;
    }
    if (this.bgEvent !== undefined) {
      this.bgEvent.paused = true;
    }
    for (let i = 0; i < this.characters.length; i++) {
      this.characters[i].togglePause(true);
    }

    for (let i = 0; i < this.tweens.length; i++) {
      let tween = this.tweens[i];
      if (tween.isPlaying) {
        this.pausedTweens.push(tween);
        tween.pause();
      }
    }

  }

  handleResumed() {
    this.paused = false;
    this.gamePlaying = true;
    //console.log('RESUMED');
    if (this.endEvent !== undefined) {
      this.endEvent.paused = false;
    }
    if (this.bgEvent !== undefined) {
      this.bgEvent.paused = false;
    }
    for (let i = 0; i < this.characters.length; i++) {
      this.characters[i].togglePause(false);
    }

    for (let i = this.pausedTweens.length - 1; i >= 0; i--) {
      this.pausedTweens[i].resume();
      this.pausedTweens.splice(i);
    }
  }

  showHelp(animate = true) {
    this.paused = true;
    this.helpPopup.show(this, animate);
  }

  changeBackground() {
    if (this.background !== undefined) {
      this.background.destroy();
    }

    let staticIdx = 0;
    let staticChars = this.staticChars.getChildren();
    // this.staticChars.clear();

    this.background = this.backgroundGroup.create(
      0,
      0,
      this.gameConfig.backgrounds[this.backgrounds].name
    );
    this.background.setOrigin(0);
    this.background.setDepth(-5);
    let charParams = this.gameConfig.backgrounds[this.backgrounds].characters;
    for (var i = 0; i < charParams.length; i++) {
      let params = charParams[i];
      if (params.type === 'static') {
        let staticChar = staticChars[staticIdx];
        staticChar.setTexture(params.name);
        staticChar.setOrigin(0.5, 1);
        staticChar.setPosition(params.posX, params.posY);
        staticChar.scaleX = params.scale * params.direction;
        staticChar.scaleY = params.scale;
        staticIdx++;
      } else {
        for (let j = 0; j < this.characters.length; j++) {
          {
            let char = this.characters[j];
            if (char.spineRef === params.name)
              char.setTransform(
                params.posX,
                params.posY,
                params.scale,
                params.scale,
                params.direction
              );
            char.canIdle = true;
            char.idleActive = true;
            char.reset();
          }
        }
      }
    }
    let prevBg = this.backgrounds;
    this.prevBackgrounds = prevBg;
    this.backgrounds++;
    if (this.backgrounds >= this.gameConfig.backgrounds.length) {
      this.backgrounds = 0;
    }

    this.backgroundGroup.setDepth(-1, 0);
  }

  createBalloon(x, y, autoStart) {
    let balloon = new Balloon(
      this,
      x,
      y,
      this.gameConfig.balloons.colours[this.balloonIndex],
      autoStart
    );
    balloon.setPhysics(this, this.balloonData);
    balloon.emitter.on('balloonClicked', () => { if (this.paused === false) { this.handleBalloonClicked(); } }, this);
    balloon.emitter.on('collided', this.handleBalloonCollision, this);
    balloon.emitter.once('gameOver', this.handleGameOver, this);
    this.balloons.push(balloon);
    this.balloonGroup.add(balloon, true);
    this.balloonGroup.setDepth(1, 0);
    this.balloonIndex = (this.balloonIndex + 1) % this.balloonColourCount;
  }

  handleBalloonClicked() {
    this.totalCount++;
    this.count++;
    this.sound.play('hit' + Phaser.Math.Between(1, 3), {
      detune: Phaser.Math.Between(95, 105) / 100
    });
    this.counter.text = this.totalCount;
    this.currentGravity = this.gravity * (1 + (this.totalCount / 750));
    if (this.count >= this.transitionCount) {
      this.handleTransition();
    } else if (this.count % 3 < 1) {
      //for (var i = 0; i < this.characters.length; i++) {
      var char = this.characters[Phaser.Math.Between(0, this.characters.length - 1)];
      this.time.delayedCall(Phaser.Math.Between(0, 500), () => char.playHappy(this), this);
      this.playTapSFX();
      /*         this.sound.play('bluey_giggle' + Phaser.Math.Between(1, 2), {
        volume: 0.5
      }); */
      //}
    }



    // if (this.totalCount % this.gameConfig.incrementThreshold == 0) {
    //   this.transitionCount += this.gameConfig.incrementAmount;
    // }
  }

  handleTransition() {
    let transitionTime = 2000;
    for (let i = 0; i < this.characters.length; i++) {
      var char = this.characters[i];
      char.canIdle = false;
      char.idleActive = false;
      char.playCelebrate(this, Phaser.Math.Between(0, 500));
    }
    this.count = 0;
    for (var j = 0; j < this.balloons.length; j++) {
      this.balloons[j].transitionOut(this, transitionTime, this.transitionDirection);
    }

    this.sound.play('transition', { volume: 0.8, delay: 0.5 });
    this.bgEvent = this.time.delayedCall(
      transitionTime + 150,
      () => this.nextBackground(),
      this
    );

    this.level ++;
    this.transitionCount = this.gameConfig.levelCount[this.level];

    console.log(this.gameConfig.levelCount[this.level],this.gameConfig.levelCount);
    if(this.transitionCount === undefined)
    {
      this.transitionCount = this.gameConfig.defaultCount;
    }
  }

  nextBackground() {
    this.changeBackground();
    this.transitionDirection = this.gameConfig.backgrounds[this.prevBackgrounds].transitionDirection;
    console.log(this.gameConfig.backgrounds[this.prevBackgrounds].name + ' --> transition direction set to ' + this.transitionDirection);
    let padding = 200;
    let x = Phaser.Math.Between(padding, this.cameras.main.width - padding);
    let y = Phaser.Math.Between(padding, 400);
    this.createBalloon(x, y, false);
    for (var i = 0; i < this.balloons.length; i++) {
      let balloon = this.balloons[i];
      // console.log('moving from ' + balloon.transform.x + ' to ' + -screenX);
      balloon.transitionIn(this, 2000, this.transitionDirection);
    }

  }

  handleBalloonCollision() {
    // console.log('BALLOON COLLISION');
    if (this.collisionPlayed == false) {
      this.sound.play('collide', { detune: Phaser.Math.Between(90, 125) / 100 });
      this.collisionPlayed = true;
      this.time.delayedCall(250, () => { this.collisionPlayed = false; });
    }
  }

  playTapSFX() {
    if (this.canPlaySFX === true) {
      let idleSound = this.idleSFX[this.idleIdx];
      //this.sound.play(idleSound, { volume: 0.6, delay: Phaser.Math.Between(200, 500) / 1000 });
      this.idleIdx = (this.idleIdx + 1) % this.idleSFX.length;
      this.canPlaySFX = false;
      this.time.delayedCall(1500, () => this.onSfxAvailable());
    }
  }

  onSfxAvailable() {
    this.canPlaySFX = true;
  }

  /**
   *  Called when a scene is updated. Updates to game logic, physics and game
   *  objects are handled here.
   *
   *  @protected
   *  @param {number} t Current internal clock time.
   *  @param {number} dt Time elapsed since last update.
   */
  update(t, dt) {
    if (this.paused === false) {
      //this.graphics.clear();
      for (let i = 0; i < this.balloons.length; ++i) {
        this.balloons[i].update(this.balloons, dt, t, this.currentGravity);
        //this.graphics.strokeCircleShape(this.balloons[i].circle);
      }

      for (var j = 0; j < this.characters.length; j++) {
        this.characters[j].updateCharacter(t, dt, this);
      }
    }
  }

  handleGameOver(popData) {
    let popX = popData.x;
    let popY = popData.y;

    this.popEffect = this.add
      .sprite(popX, popY)
      .play('balloonPop');
    this.popEffect.tint = popData.tint;
    for (let i = 0; i < this.balloons.length; ++i) {
      this.balloons[i].stop();
    }
    for (let j = 0; j < this.characters.length; j++) {
      this.characters[j].playSad(this);
    }

    this.gamePlaying = false;

    this.sound.play('pop');
    this.endEvent = this.time.delayedCall(2000, () => this.outroComplete());
  }

  outroComplete() {
    this.popEffect.destroy();
    this.popEffect = null;
    this.handlePaused();
    this.bgMusic.stop();
    this.lastBG = this.backgrounds;
    this.createGameOverPopup();
  }

  setupCharacters(data) {
    for (var i = 0; i < data.characters.length; i++) {
      let charData = data.characters[i];
      let character = new BaseCharacter(
        this,
        i,
        charData.spine,
        charData.skin,
        charData.animations,
        charData.sfx
      );
      character.togglePause(false);
      this.characterGroup.add(character);
      this.characters.push(character);
    }
  }

  createGameOverPopup() {
    if (this.gameOverPopup !== undefined) {
      this.gameOverPopup.destroy();
    }

    this.gameOverPopup = new GameOverPopup(this, this.popupGroup, this.endConfig);
    this.popupGroup.add(this.gameOverPopup, true);
    this.popupGroup.setDepth(15, 0);
  }

  destroy() {
    console.log('Desroy');
    if (this.gameOverPopup !== null) {
      this.gameOverPopup.destroy();
    }
    this.backgroundGroup.destroy();
    this.staticChars = null;
    this.balloonGroup.destroy();
    this.textGroup.destroy();
    this.gameConfig.destroy();
    this.endConfig.destroy();
    this.helpConfig.destroy();
    this.balloonData.destroy();
    this.counter.destroy();
    this.characterGroup.destroy();
    this.popupGroup.destroy();
    this.uiGroup.destroy();
    super.destroy();
  }
}
